import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  HStack,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import { ContractAcceptationType, PaymentNotificationTypeValues, SelectionType } from 'BrokerTsLib/src/enums'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'

import { FormLabel } from '../components/FormLabel'
import {
  FormSection,
  FormSectionBody,
  FormSectionHeader,
  FormSectionTitle,
} from '../components/FormSection'
import { Loading } from '../components/Loading'
import { MainContent } from '../components/MainContent'
import { useSelections } from '../hooks'
import { useApp } from '../hooks/useApp'
import { useGetAvailableBusinessmen } from '../hooks/useInsuranceParams'
import { meetingRecordContext } from '../pages/carkulka/wizard/5'
import { AvailableCustomerKnowledge } from './MeetingRecordForm'

export const MeetingRecordOverview = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { app } = useApp()
  const { insuranceParamsId } = useParams()
  const { meetingRecord, isLoading } = useContext(meetingRecordContext)
  const { data: dataBusinessmen } = useGetAvailableBusinessmen(insuranceParamsId!)
  const { data: dataFS } = useSelections(SelectionType.FormaSjednani)
  const { data: dataFirstPaymentType } = useSelections(SelectionType.ZpusobPrvniPlatby)
  const { data: dataDigitalSignatureType } = useSelections(SelectionType.ZpusobDigitalnihoPodpisu)

  const isBusinessmanOrManager = !!meetingRecord && !!dataBusinessmen //&& (!!meetingRecord.businessmanId || !!meetingRecord.managerId)


  return (
    <MainContent>
      <FormSection>
        <FormSectionHeader>
          <FormSectionTitle>Záznam z jednání</FormSectionTitle>
        </FormSectionHeader>

        <FormSectionBody sx={{ gap: 8 }}>
          {isOpen && (
            <>
              {isLoading && <Loading large={true} />}
              {!isLoading && <Box sx={{ display: 'grid', gap: 4 }}>
                <FormControl variant="fullWidth">
                  <FormLabel>
                    Případné nesrovnalosti mezi požadavky Zákazníka a sjednávaným pojištěním nebo jeho
                    podstatnou změnou
                  </FormLabel>
                  {<Text>{meetingRecord?.irregularities ? meetingRecord?.irregularities : 'Žádné nesrovnalosti.'}</Text>}
                </FormControl>

                <FormControl>
                  <FormLabel>Důvody, na kterých je doporučení založeno</FormLabel>
                  {<Text>{meetingRecord?.reasons ? meetingRecord?.reasons : 'Žádné důvody.'}</Text>}
                </FormControl>

                <FormControl variant="fullWidth">
                  <FormLabel>
                    Popis dopadů sjednání/změny/ukončení pojištění, včetně souvisejících rizik - V případě doporučení sjednání nové pojistné smlouvy nebo její podstatné změny je třeba vysvětlit dopady takového jednání vč. souvisejících rizik u každého sjednaného pojistného produktu.
                  </FormLabel>
                  {<Text>{meetingRecord?.consequences ? meetingRecord?.consequences : 'Žádný popis.'}</Text>}
                </FormControl>

                <FormControl>
                  <FormLabel tooltip="Zákazník odmítá sdělit další požadavky?">
                    Zákazník odmítá sdělit další požadavky?
                  </FormLabel>
                  <Text>{meetingRecord?.refusesMoreDetails ? 'Ano' : 'Ne'}</Text>
                </FormControl>

                <FormControl variant="fullWidth">
                  <FormLabel>
                    Další požadavky, potřeby a cíle zákazníka
                  </FormLabel>
                  {<Text>{meetingRecord?.additionalClientRequirements ? meetingRecord?.additionalClientRequirements : 'Žádné další požadavky.'}</Text>}
                </FormControl>

                <FormControl>
                  <FormLabel tooltip="Má zákazník vedle této pojistné smlouvy uzavřenou další se stejným krytím?">
                    Má zákazník vedle této pojistné smlouvy uzavřenou další se stejným krytím?
                  </FormLabel>
                  <Text>{meetingRecord?.hasMoreContracts ? 'Ano' : 'Ne'}</Text>
                </FormControl>

                {app != 'cestovko' &&
                  <FormControl>
                    <FormLabel tooltip="Jaké má zákazník znalosti produktů?">
                      Jaké má zákazník znalosti produktů?
                    </FormLabel>
                    <Text>{AvailableCustomerKnowledge.find(x => x.id == meetingRecord?.customerKnowledge)?.name}</Text>
                  </FormControl>
                }

                <Checkbox isChecked={meetingRecord?.noCollison} isReadOnly>
                  Zákazník ani Zprostředkovatel si nejsou vědomi žádných nesrovnalostí mezi požadavky Zákazníka a nabízeným pojištěním.
                </Checkbox>

                <FormControl>
                  <FormLabel>Místo sjednání</FormLabel>
                  <Text>{meetingRecord?.placeOfContract}</Text>
                </FormControl>

                <FormControl>
                  <FormLabel>Druh smlouvy</FormLabel>
                  <Text>{meetingRecord?.previousContractNumber ? 'Náhrada stávající smlouvy' : 'Nová smlouva'}</Text>
                </FormControl>

                {meetingRecord?.previousContractNumber &&
                  <FormControl>
                    <FormLabel>Číslo stávající smlouvy</FormLabel>
                    <Text>{meetingRecord.previousContractNumber}</Text>
                  </FormControl>
                }

                {app != 'cestovko' &&
                  <>
                    <FormControl>
                      <FormLabel>Způsob sjednání</FormLabel>
                      <Text>{dataFS?.find(x => x.value == meetingRecord?.startType)?.description}</Text>
                    </FormControl>

                    <FormControl>
                      <FormLabel tooltip="Upozornění na blížící se datum splatnosti prvního pojistného">
                        Upozornění na blížící se datum splatnosti prvního pojistného
                      </FormLabel>

                      <HStack>
                        <Checkbox value="insuree" isChecked={meetingRecord?.contractExpiryWarning?.includes(PaymentNotificationTypeValues.Broker)} isReadOnly>
                          Sjednatel
                        </Checkbox>
                        <Checkbox value="customer" isChecked={meetingRecord?.contractExpiryWarning?.includes(PaymentNotificationTypeValues.Client)} isReadOnly>
                          Zákazník
                        </Checkbox>
                      </HStack>
                    </FormControl>
                  </>
                }

                {meetingRecord?.firstPaymentType && meetingRecord?.startType == ContractAcceptationType.Payment &&
                  <FormControl>
                    <FormLabel>Způsob první platby</FormLabel>
                    <Text>{dataFirstPaymentType?.find(x => x.id == meetingRecord?.firstPaymentType)?.description}</Text>
                  </FormControl>
                }

                {meetingRecord?.digitalSignatureType && meetingRecord?.startType == ContractAcceptationType.DigitalSignature &&
                  <FormControl>
                    <FormLabel>Způsob digitálního podpisu</FormLabel>
                    <Text>{dataDigitalSignatureType?.find(x => x.id == meetingRecord?.digitalSignatureType)?.description}</Text>
                  </FormControl>
                }

                {meetingRecord?.contractArrangedRemotelyEnabled &&
                  <FormControl>
                    <FormLabel>Smlouva je sjednána</FormLabel>
                    <Text>{meetingRecord?.isContractArrangedRemotely ? 'Na dálku' : 'Osobně'}</Text>
                  </FormControl>
                }

                {isBusinessmanOrManager &&
                  <>
                    <FormLabel >Sjednání za jiného uživatele</FormLabel>

                    <Box sx={{ display: 'grid', gap: 4 }}>
                      <HStack>
                        <FormLabel >Ziskatel</FormLabel>
                        <Text>{meetingRecord.businessmanFullname ?? 'Neuveden'}</Text>
                      </HStack>

                      <HStack>
                        <FormLabel >Správce</FormLabel>
                        <Text>{meetingRecord.managerFullname ?? 'Neuveden'}</Text>
                      </HStack>
                    </Box>
                  </>
                }

                <FormControl>
                  <FormLabel>Získatelské číslo</FormLabel>
                  {meetingRecord?.brokerNumbers.map(item => <Text key={item.acquisitionNumber}>{item.acquisitionNumber}</Text>)}
                </FormControl>
              </Box>}
            </>
          )}

          <Flex sx={{ w: '100%', placeContent: 'end' }}>
            <Button variant="outline" onClick={isOpen ? onClose : onOpen}>
              {isOpen ? 'Skrýt záznam z jednání' : 'Zobrazit záznam z jednání'}
            </Button>
          </Flex>
        </FormSectionBody>
      </FormSection>
    </MainContent>
  )
}
